<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Diners Club" class="d-icon d-icon--diners-club" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x=".25" y="3.75" width="23.5" height="16.5" rx="1.75" fill="#fff" stroke="#E3E5E8" stroke-width=".5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.18 16.623h1.833c2.86 0 5.14-2.269 5.229-5.072v-.045c-.045-2.848-2.369-5.162-5.23-5.117h-2.055c-2.727.089-4.872 2.403-4.783 5.162 0 2.759 2.235 5.028 5.006 5.072Zm-4.112-5.117c0-2.314 1.922-4.227 4.246-4.227 2.324 0 4.246 1.913 4.246 4.227s-1.922 4.227-4.246 4.227c-2.324 0-4.246-1.913-4.246-4.227Zm4.917 2.848V8.703c1.564.4 2.547 1.958 2.145 3.515a2.904 2.904 0 0 1-2.145 2.136Zm-3.442-3.56a2.924 2.924 0 0 0 2.1 3.56V8.703a2.933 2.933 0 0 0-2.1 2.091Z" fill="#0079BE"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDinersClub',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
